import auth_de from './auth/de'
import nav_de from './nav/de'
import dashboard_de from './dashboard/de'
import user_de from './user/de'
import item_de from './item/de'
import set_de from './set/de'
import tag_de from './tag/de'
import plan_de from './plan/de'
import common_de from './common/de'
import exhibition_de from './exhibition/de'
import manual_de from './manual/de'

export default {
  auth: auth_de,
  nav: nav_de,
  dashboard: dashboard_de,
  user: user_de,
  item: item_de,
  set: set_de,
  tag: tag_de,
  plan: plan_de,
  common: common_de,
  exhibition: exhibition_de,
  manual: manual_de
}
